import { request } from "@/utils/request";
/**
 * 查询
 * @param {*} data 
 * @returns 
 */
export function selectApi(data) {
  return request({
    url: `/admin/storeInfo/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data 
 * @returns 
 */
export function addApi(data) {
  return request({
    url: `/admin/storeInfo/add`,
    method: "POST",
    data,
  });
}

/**
 * 修改
 * @param {*} data 
 * @returns 
 */
export function updateApi(data) {
  return request({
    url: `/admin/storeInfo/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data 
 * @returns 
 */
export function deleteApi(data) {
  return request({
    url: `/admin/storeInfo/delete`,
    method: "POST",
    data,
  });
}


/*根据店铺id数组查询店铺列表 */
export function queryMyselfStore(data) {
  return request({
    url: `/admin/storeInfo/queryMyselfStore`,
    method: "POST",
    data,
  });
}


/**
 * 生成门店二维码
 * @param {*} data
 * @returns
 */
export function createCode(data) {
  return request({
    url: `/getCode/create`,
    method: "POST",
    data,
    isDecrypt: false,
    isEncrypt: true,
  });
}
